import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/core/service/request.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResSearchService {

  constructor(
      private requestService: RequestService
    ) { }
  
    SearchResData(CompanyID:string,UserID:string){
      var param = {
        "CompanyID": CompanyID,
        "UserID": UserID
      };
      return this.requestService.Post<any>(environment.baseUrl + '/Reservation/SearchResData',param);
    }
    CancelReservation(value: any){
      return this.requestService.Post<any>(environment.baseUrl + '/Reservation/CancelReservation',value);
    }
    GetConsentForm(value: any){
      var param = {
        "model": value,
        "type": "1"
      };
      return this.requestService.Post<any>(environment.baseUrl + '/Reservation/GetConsentFormForLine',param);
    }
    SaveSign(value: any){
      return this.requestService.Post<any>(environment.baseUrl + '/Reservation/SaveResSign',value);
    }
}
